export default function labelClass(label) {
  if (!label) return '';
  return 'ClassifiedsLabel ClassifiedsLabel--' + String(label).toLowerCase();
}
flarum.reg.add('ramon-classifieds', 'common/utils/labelClass', labelClass);